import { render, staticRenderFns } from "./FormVeiculo.vue?vue&type=template&id=01661e65&scoped=true"
import script from "./FormVeiculo.vue?vue&type=script&lang=js"
export * from "./FormVeiculo.vue?vue&type=script&lang=js"
import style0 from "./FormVeiculo.vue?vue&type=style&index=0&id=01661e65&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01661e65",
  null
  
)

export default component.exports